export enum SubtabItemActiveColorScheme {
  '1st' = '1st',
  '2nd' = '2nd',
}
